// extracted by mini-css-extract-plugin
module.exports = {"container":"_50237d5","image":"_e246f15","name":"_f4355f5","registration":"_70d70d7","meta":"_2858821","detailsContainer":"_db1fea8"};